export default "__VITE_ASSET__wM5Ro5RD__"